import type { FaqItem } from "@/components/feature/FaqAccordion";

/**
 * Trip-planner FAQs for the /plan-your-trip page. These power both the
 * on-page FAQ accordion and the matching FAQPage structured data.
 */
export const planTripFaqs: FaqItem[] = [
  {
    q: "Do I need to book in advance to plan a trip?",
    a: "For farm experiences we recommend planning at least 3 to 5 days ahead so the host families can arrange around their farm work. Weekends, holidays and the cooler October to February window fill up fastest. The trip builder itself has no deadline — you can draft an itinerary any time.",
  },
  {
    q: "Can I mix experiences from different farms in one trip?",
    a: "Absolutely. Once you've added items in the trip builder you can reorder, swap or combine them across farms and villages. Our team will then help arrange the driving distances and timings so the days flow smoothly without rushing between hosts.",
  },
  {
    q: "How many days do I need to see Konaseema properly?",
    a: "Most visitors find 2 to 3 days is a comfortable pace — enough for one or two farm experiences, a village or backwater tour, and time to slow down. If you want to cover several farms, the mango season or the paddy harvest, plan for 3 to 4 nights.",
  },
  {
    q: "Is a farm visit suitable for young children or elderly parents?",
    a: "Yes. Our hosts regularly welcome children and older guests, and activities can be paced and adjusted so everyone joins in comfortably. Just tell us who's coming in your trip notes and we'll choose farms and timings that suit your group.",
  },
  {
    q: "What should I pack for a farm visit?",
    a: "Light, comfortable clothing you don't mind getting dusty, closed shoes for field and village walks, a hat or cap, sunscreen, a water bottle and any personal medication. For early mornings and evenings a light layer helps, and a reusable bag is handy for anything you pick or buy.",
  },
  {
    q: "How do I confirm my itinerary after building it?",
    a: "Share the plan you've built through our contact form or WhatsApp. Our team checks availability with each farm, confirms dates, timings and logistics, and gets back to you with a final itinerary and the total cost before anything is confirmed.",
  },
];